<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Toolbar.cookies") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                <v-layout row wrap>
                  <v-flex xs6 lg4>
                    <!-- <v-select :items="AllService" item-text="ServiceName" return-object v-model="SelectName"
                      color="#077893" dense outlined style="cursor: pointer" label="Service"
                      @change="GetService()"></v-select> -->
                    <v-btn color="#077893" outlined to="/cookies-add">
                      <v-icon class="mr-1">mdi-plus</v-icon
                      >{{ $t("Cookies.text1") }}
                    </v-btn>
                    <br />
                    <br />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex d-flex justify-end lg4>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-layout row wrap justify-center align-center>
                <v-flex lg12>
                  <v-data-table
                    :search="Search"
                    :loading="tableload"
                    :loading-text="$t('overlay.load')"
                    :headers="headers"
                    :items="AllService"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    @page-count="pageCount = $event"
                  >
                    <template v-slot:[`item.ServiceName`]="{ item }">
                      <div v-if="item.ServiceName.length > 13">
                        {{ item.ServiceName }}
                      </div>
                      <div v-else>
                        {{ item.ServiceName }}
                      </div>
                    </template>
                    <template v-slot:[`item.ServiceId`]="{ item }">
                      {{ item.ServiceId }}
                    </template>
                    <template v-slot:[`item.Name`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.Name }}
                      </div>
                      <div v-else>{{ item.NameEng }}</div>
                    </template>
                    <template v-slot:[`item.CreatedAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.CreatedAt }}
                      </div>
                      <div v-else>
                        {{ item.CreatedAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            fab
                            color="#077893"
                          >
                            <v-icon dark size="20">
                              mdi-format-list-bulleted-square
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                          <v-list-item
                            link
                            @click="fn_checkActionType(list.service, item)"
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon :color="list.color"
                                >{{ list.icon }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                              v-if="$t('default') === 'th'"
                              :inner-text.prop="list.text"
                              style="font-size: 14px"
                            ></v-list-item-title>
                            <v-list-item-title
                              v-else
                              :inner-text.prop="list.text2"
                              style="font-size: 14px"
                            ></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12>
                  <div class="text-center pt-2">
                    <v-pagination
                      :total-visible="7"
                      class="pt-2 pb-2"
                      circle
                      color="#077893"
                      v-model="page"
                      :length="pageCount"
                      prev-icon="mdi-menu-left"
                      next-icon="mdi-menu-right"
                    >
                    </v-pagination>
                  </div>
                </v-flex>
              </v-layout>
              <v-card-text class="black--text">
                <div v-if="SelectName !== ''">
                  <h2 class="pb-6 pt-5">
                    Webscript
                    <v-btn
                      color="#dff7ff"
                      class="ma-2 black--text"
                      small
                      fab
                      @click="openScript = !openScript"
                    >
                      <v-icon dark color="#077893"> mdi-script </v-icon>
                    </v-btn>
                  </h2>
                  <v-divider></v-divider>
                  <v-layout row wrap pt-6 justify-center align-center pa-3>
                    <v-flex xs12 lg12 md12>
                      <v-card
                        outlined
                        color="#dff7ff"
                        class="pa-2"
                        v-if="openScript"
                      >
                        <div class="text-end">
                          <v-icon
                            color="#077893"
                            style="cursor: pointer"
                            @click="Fn_CopyDetail(WebScript)"
                            >mdi-file-multiple-outline</v-icon
                          >
                        </div>
                        <div
                          class="textcolor"
                          v-for="(item, index) in Script"
                          :key="index"
                        >
                          {{ item }}
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogCookiesDelete
        :show="DialogCookiesDelete"
        :_item="ItemDelete"
        @closeDialogDelete="DialogCookiesDelete = false"
        @reData="GetAllService()"
      />
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import DialogCookiesDelete from "@/components/dialog/DialogCookiesDelete";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import authorization from "@/functions/authorization.js";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogCookiesDelete, OverlaySearch },
  data: function () {
    return {
      Search: "",
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      ItemPolicy: [],
      ItemDelete: [],
      // DialogDelete: false,
      loadingDownloadData: false,
      items: ["Test", "Bar", "Fizz", "Buzz"],
      SelectName: "",
      itemsAction: [
        {
          icon: "mdi-pencil",
          text: "แก้ไขข้อมูล",
          text2: "Edit",
          color: "orange",
          service: "Edit",
        },
        {
          icon: "mdi-trash-can",
          text: "ลบข้อมูล",
          text2: "Delete",
          color: "red",
          service: "Del",
        },
        {
          icon: "mdi-text-box-search",
          text: "ดูรายละเอียด",
          text2: "Preview",
          color: "success",
          service: "Preview",
        },
      ],
      AllService: [],
      Service: "",
      Name: "",
      NameEng: "",
      ServiceId: "",
      SecretId: "",
      Hostname: "",
      CreatedAt: "",
      CreatedAtEng: "",
      ServiceName: "",
      UpdatdeAt: "",
      UpdatdeAtEng: "",
      GroupId: "",
      ConsentId: "",
      PolicyId: "",
      DialogCookiesDelete: false,
      DialogDelete: false,
      ItemDelete: [],
      SecretIdCopy: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      tableload: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    ...mapGetters(["Profile"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },

    headers() {
      return [
        {
          text: "Service Name",
          value: "ServiceName",
          align: "center",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("Cookies.text4"),
          align: "center",
          value: "Hostname",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("mcg.row3"),
          align: "center",
          value: "Name",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("onechat.date"),
          align: "center",
          value: "CreatedAt",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("policyForm.select"),
          value: "action",
          sortable: false,
          width: "20%",
          align: "center",
        },
      ];
    },
  },
  companyth: {
    get() {
      if (this.$i18n.locale === "th") {
        return this.profile.name_on_document_th;
      } else {
        return this.profile.name_on_document_eng;
      }
    },
  },
  mounted() {
    this.GetAllService();
  },
  methods: {
    async Fn_CopyDetail(val) {
      if (val === this.SecretId) {
        val = this.SecretIdCopy;
        await navigator.clipboard.writeText(val);
      } else {
        await navigator.clipboard.writeText(val);
      }
    },
    Fn_EditHostName() {},
    Fn_Delete(item) {
      this.DialogCookiesDelete = true;
      this.ItemDelete = item;
    },
    fn_checkActionType(val, item) {
      if (val == "Edit") {
        this.Fn_Update(item);
      } else if (val == "Del") {
        this.Fn_Delete(item);
      } else if (val == "Preview") {
        this.Fn_Detail(item);
      }
    },
    async GetAllService() {
      this.loadingDownloadData = true;
      this.tableload = true;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      // var Headers = {
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "webscript/GetAllService",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.tableload = false;
          if (response.data.Status === "OK") {
            this.AllService = response.data.Message;

            var index = 0;
            for (var item of this.AllService) {
              index += 1;
              item.no = index;
            }
            // this.SelectName = response.data.Message.SelectName;
 
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          this.tableload = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Update(item) {
      this.$cookies.set("ServiceId", item.ServiceId);

      this.$router.push({ path: "/cookies-update" });
    },
    Fn_Detail(item) {
      this.$cookies.set("ServiceId", item.ServiceId);
      this.$router.push({ path: "/cookies-detail" });
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.blurry-text {
  font-size: 14px;
  color: transparent;
  text-shadow: 0 0 8px #000;
}

.textcolor {
  color: #077893;
}

.v-progress-circular {
  margin: 1rem;
}

.yellow {
  color: yellow;
}

.green {
  color: green;
}

.red {
  color: red;
}
</style>
